import React, { FC } from 'react';
import { Box, Grid } from '@mui/material';
import { Listing } from '../../graphql/generated';
import ProductCard from './ProductCard';
import { ADD_TO_CART, CREATE_CART } from '../../graphql/mutations';
import { useMutation } from '@apollo/client';
import PlaceholderPage from '../MyBiz/PlaceholderPage';
import { toast } from 'react-toastify';

interface ProductListProps {
  products: Listing[];
}

const ProductList: FC<ProductListProps> = ({ products }) => {

  const emptyImage2 = require("../../assets/images/Empty2.png");
  const [addToCart] = useMutation(ADD_TO_CART);
  const [createCart] = useMutation(CREATE_CART);

  const handleAddToCart = async (productId: string) => {
    const cartId = localStorage.getItem('shopifyCartId'); // Check for existing cartId in local storage

    try {
      if (cartId) {
        // Add to existing cart
        await addToCart({
          variables: {
            cartId,
            items: [
              {
                merchandiseId: productId,
                quantity: 1,
              },
            ],
          },
        });
      } else {
        // Create a new cart
        const response = await createCart({
          variables: {
            items: [
              {
                merchandiseId: productId,
                quantity: 1,
              },
            ],
          },
        });

        const newCart = response.data.createCart;

        // Save the new cart ID to local storage
        localStorage.setItem('shopifyCartId', newCart.id);
      }

      toast.success('Item added to cart!');
    } catch (error: any) {
      console.error('Error adding to cart:', error.message);
      toast.error('Failed to add item to cart. Please try again.');
    }
  };

  return (
    <Box p={2}>
      <Grid container spacing={1} rowSpacing={4}>
        {products?.length > 0 ?
          (products.map((product) => (
            <Grid item xs={12} sm={6} md={3} key={product.id}>
              <ProductCard listing={product} onAddToCart={handleAddToCart} />
            </Grid>
          )))
          :
          <PlaceholderPage
            title="Empty Search"
            emptyStateText="Your search returned no results"
            emptyStateImage={emptyImage2}
            actionButtons={<></>}
          />
        }
      </Grid>
    </Box>
  );
};

export default ProductList;
